<template lang="pug">
#bloco-tabela-territorio-gestao
    .tabela-certificacoes-inseridas-listagem
        el-tooltip(
            effect='dark',
            content='Recarregar tabela',
            placement='top',
            v-if='btnRecarregar'
        )
            el-button(
                type='primary',
                icon='el-icon-refresh',
                size='mini',
                @click.native='atualizarTabela'
            )
    el-table(
        :key="listagemTableKey('certificacao', tabelaData, paginacao.pagina + 1)",
        :data='tabelaData',
        v-loading='carregando',
        style='width: 100%',
        @sort-change='sortChangeRequest',
        :default-sort='{ prop: "dataCadastro", order: "ascending" }',
        stripe
    )
        el-table-column(type='expand', width='45', align='center')
            template(slot-scope='scope')
                el-descriptions.descricao-item-tabela.areas(
                    :size='"mini"',
                    :column='9'
                )
                    el-descriptions-item.area-total(
                        label='Área total do território',
                        span='2'
                    )
                        p.area-ha {{ formatarArea(scope.row.geometrias[0].areaHaTerritorio) }} ha
                    el-descriptions-item.area-total(
                        label='Área de plantio do território',
                        span='2'
                    )
                        p.area-ha {{ scope.row.geometrias[0].areaPlantadaHa ? formatarArea(scope.row.geometrias[0].areaPlantadaHa) + ' ha' : '-' }}

                    el-descriptions-item(
                        :label='scope.row.possuiCertificacaoRelacionada ? "Recorte 2BSvs" : "2BSvs"'
                    )
                        p {{ scope.row.geometrias[0].areaElegivel2BSvs ? formatarArea(scope.row.geometrias[0].areaElegivel2BSvs) + ' ha' : '-' }}

                    el-descriptions-item(label='PROTERRA')
                        p {{ scope.row.geometrias[0].areaElegivelProterra ? formatarArea(scope.row.geometrias[0].areaElegivelProterra) + ' ha' : '-' }}

                    el-descriptions-item(label='RTRS')
                        p {{ scope.row.geometrias[0].areaElegivelRTRS ? formatarArea(scope.row.geometrias[0].areaElegivelRTRS) + ' ha' : '-' }}

                    el-descriptions-item(label='EPA')
                        p {{ scope.row.geometrias[0].areaElegivelEPA ? formatarArea(scope.row.geometrias[0].areaElegivelEPA) + ' ha' : '-' }}

                    el-descriptions-item(label='EUDR')
                        p {{ scope.row.geometrias[0].areaElegivelEUDR ? formatarArea(scope.row.geometrias[0].areaElegivelEUDR) + ' ha' : '-' }}
                el-descriptions.descricao-item-tabela(:size='"mini"')
                    el-descriptions-item(
                        label='Pessoas:',
                        v-if='scope.row.representantes && scope.row.representantes.length > 1'
                    )
                        .representantes(
                            v-for='representante in scope.row.representantes',
                            :key='representante.id'
                        )
                            p {{ representante.nomeRepresentante }}

                el-descriptions.descricao-item-tabela(
                    :size='"mini"',
                    v-if='scope.row.representantes && scope.row.representantes.length === 1'
                )
                    el-descriptions-item.has-colon-not(
                        label='Esse território não possui pessoas adicionais.'
                    )

                el-descriptions.descricao-item-tabela(
                    :size='"mini"',
                    v-if='scope.row.representantes && scope.row.representantes.length === 0'
                )
                    el-descriptions-item.has-colon-not(
                        label='Esse território não possui pessoas.'
                    )

                el-descriptions.descricao-item-tabela(:size='"mini"')
                    el-descriptions-item(
                        label='CAR:',
                        v-if='scope.row.cars && scope.row.cars.length > 1'
                    )
                        .car-list-row
                            .cars(
                                v-for='car in scope.row.cars',
                                :key='car?.codigo'
                            )
                                p {{ car?.codigo }}

                    el-descriptions.descricao-item-tabela(
                        :size='"mini"',
                        v-if='scope.row.cars && scope.row.cars.length === 1'
                    )
                        el-descriptions-item.has-colon-not(
                            label='Esse território não possui CARS adicionais.'
                        )

                    el-descriptions.descricao-item-tabela(
                        :size='"mini"',
                        v-if='scope.row.cars && scope.row.cars.length === 0'
                    )
                        el-descriptions-item.has-colon-not(
                            label='Esse território não possui CARS.'
                        )

        el-table-column(
            prop='nomeTerritorio',
            label='Território',
            width=auto,
            max-width='400',
            serializable='true',
            flex='1'
        )
            template(slot-scope='scope')
                .car(v-if='scope.row?.nomeTerritorio')
                    p.territorio-hiden-row {{ scope.row?.nomeTerritorio.toUpperCase() }}

                .territorio(v-else)
                    p -

        el-table-column(
            prop='cars',
            label='CAR',
            width=auto,
            max-width='200',
            flex='1'
        )
            template(slot-scope='scope')
                .car(v-if='scope.row.cars && scope.row.cars.length > 0')
                    p.car-hiden-row {{ scope.row.cars[0]?.codigo }}
                .car(v-else)
                    p -

        el-table-column(
            prop='dataUltimaAnalise',
            label='Última análise',
            max-width='35',
            min-width='35',
            flex='1',
            align='center'
        )
            template(slot-scope='scope')
                div(v-if='scope.row.dataUltimaAnalise')
                    p {{ scope.row.dataUltimaAnalise }}
                div(v-else)
                    p -

        el-table-column(
            prop='laudo',
            label='Laudo',
            width='75',
            flex='1'
        )
            template(slot-scope='scope')
                .laudo(v-if='scope.row.laudoAnaliseFinalizada', @click='realizarDownloadLaudo(scope.row)')
                    el-icon.el-icon-download
                p(v-else) -

        el-table-column.elegivel(
            prop='certificacaoTerritorioResultado',
            label='2BSvs',
            width='100',
            flex='1'
        )
            template(slot-scope='scope')
                .flex-container
                    div(v-if='scope.row.certificacaoTerritorioResultado[0]')
                        .certificacaoTipo(
                            v-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "NAO_ANALISADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove-outline.nao-analisado

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "EM_ANALISE"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "INELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-error.inelegivel {{ scope.row.certificacaoTerritorioResultado[0].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "PARCIALMENTE_ELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-warning.parcialmente-elegivel {{ scope.row.certificacaoTerritorioResultado[0].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "NAO_SE_APLICA"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove.nao-se-aplica {{ scope.row.certificacaoTerritorioResultado[0].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "LAUDO_SOLICITADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-add.disabled-font-color {{ scope.row.certificacaoTerritorioResultado[0].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "EM_ANALISE"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading {{ scope.row.certificacaoTerritorioResultado[0].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "PROCESSADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-checked.sucess-font-color {{ scope.row.certificacaoTerritorioResultado[0].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "ERRO_PROCESSAMENTO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-delete.error-font-color {{ scope.row.certificacaoTerritorioResultado[0].resultadoNome }}

                        .certificacaoTipo(v-else)
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[0].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-success(
                                    :class='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo === "ELEGIVEL" || scope.row.certificacaoTerritorioResultado[0].resultadoParcial === "ELEGIVEL" ? "elegivel" : "danger-font-color"'
                                )

                    div(v-else)
                        .certificacaoTipo
                            el-icon.el-icon-loading

                    div(v-if='scope.row.certificacaoTerritorioResultado[0].resultadoCodigo !== "NAO_ANALISADO" && scope.row.certificacaoTerritorioResultado[0].resultadoCodigo !== "EM_ANALISE"')
                        el-tooltip(
                            effect='dark',
                            :content='scope.row.certificacoes[0].status ? "Certificado" : "Não certificado"',
                            placement='top'
                        )
                            el-icon.el-icon-star-on(
                                :class='scope.row.certificacoes[0].status ? "certificado" : "nao-certificado"'
                            )

        el-table-column.elegivel(
            prop='certificacaoTerritorioResultado',
            label='Proterra',
            width='100',
            flex='1'
        )
            template(slot-scope='scope')
                .flex-container
                    div(v-if='scope.row.certificacaoTerritorioResultado[1]')
                        .certificacaoTipo(
                            v-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "EM_ANALISE"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "NAO_ANALISADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove-outline.nao-analisado

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "INELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-error.inelegivel {{ scope.row.certificacaoTerritorioResultado[1].resultadoNome }}
                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "PARCIALMENTE_ELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-warning.parcialmente-elegivel {{ scope.row.certificacaoTerritorioResultado[1].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "NAO_SE_APLICA"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove.nao-se-aplica {{ scope.row.certificacaoTerritorioResultado[1].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "LAUDO_SOLICITADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-add.disabled-font-color {{ scope.row.certificacaoTerritorioResultado[1].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "EM_ANALISE"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading {{ scope.row.certificacaoTerritorioResultado[1].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "PROCESSADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-checked.sucess-font-color {{ scope.row.certificacaoTerritorioResultado[1].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "ERRO_PROCESSAMENTO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-delete.error-font-color {{ scope.row.certificacaoTerritorioResultado[1].resultadoNome }}

                        .certificacaoTipo(v-else)
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-success(
                                    :class='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo === "ELEGIVEL" || scope.row.certificacaoTerritorioResultado[1].resultadoParcial === "ELEGIVEL" ? "elegivel" : "danger-font-color"'
                                )

                    div(v-else)
                        .certificacaoTipo
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[1].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading
                    div(v-if='scope.row.certificacaoTerritorioResultado[1].resultadoCodigo !== "NAO_ANALISADO" && scope.row.certificacaoTerritorioResultado[1].resultadoCodigo !== "EM_ANALISE"')
                        el-tooltip(
                            effect='dark',
                            :content='scope.row.certificacoes[1].status ? "Certificado" : "Não certificado"',
                            placement='top'
                        )
                            el-icon.el-icon-star-on(
                                :class='scope.row.certificacoes[1].status ? "certificado" : "nao-certificado"'
                            )

        el-table-column.elegivel(
            prop='certificacaoTerritorioResultado',
            label='RTRS',
            width='100',
            flex='1'
        )
            template(slot-scope='scope')
                .flex-container
                    div(v-if='scope.row.certificacaoTerritorioResultado[2]')
                        .certificacaoTipo(
                            v-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "NAO_ANALISADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove-outline.nao-analisado

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "INELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-error.inelegivel {{ scope.row.certificacaoTerritorioResultado[2].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "PARCIALMENTE_ELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-warning.parcialmente-elegivel {{ scope.row.certificacaoTerritorioResultado[2].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "NAO_SE_APLICA"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove.nao-se-aplica {{ scope.row.certificacaoTerritorioResultado[2].resultadoNome }}
                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "LAUDO_SOLICITADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-add.disabled-font-color {{ scope.row.certificacaoTerritorioResultado[2].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "EM_ANALISE"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading {{ scope.row.certificacaoTerritorioResultado[2].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "PROCESSADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-checked.sucess-font-color {{ scope.row.certificacaoTerritorioResultado[2].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "ERRO_PROCESSAMENTO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-delete.error-font-color {{ scope.row.certificacaoTerritorioResultado[2].resultadoNome }}

                        .certificacaoTipo(v-else)
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[2].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-success(
                                    :class='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo === "ELEGIVEL" || scope.row.certificacaoTerritorioResultado[2].resultadoParcial === "ELEGIVEL" ? "elegivel" : "danger-font-color"'
                                )

                    div(v-else)
                        .certificacaoTipo
                            el-icon.el-icon-loading

                    div(v-if='scope.row.certificacaoTerritorioResultado[2].resultadoCodigo !== "NAO_ANALISADO" && scope.row.certificacaoTerritorioResultado[2].resultadoCodigo !== "EM_ANALISE"')
                        el-tooltip(
                            effect='dark',
                            :content='scope.row.certificacoes[2].status ? "Certificado" : "Não certificado"',
                            placement='top'
                        )
                            el-icon.el-icon-star-on(
                                :class='scope.row.certificacoes[2].status ? "certificado" : "nao-certificado"'
                            )

        el-table-column.elegivel(
            prop='certificacaoTerritorioResultado',
            label='EPA',
            width='75',
            flex='1'
        )
            template(slot-scope='scope')
                .flex-container
                    div(v-if='scope.row.certificacaoTerritorioResultado[3]')
                        .certificacaoTipo(
                            v-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "NAO_ANALISADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove-outline.nao-analisado

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "INELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-error.inelegivel {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "PARCIALMENTE_ELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-warning.parcialmente-elegivel {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "NAO_SE_APLICA"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove.nao-se-aplica {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "LAUDO_SOLICITADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-add.disabled-font-color {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "EM_ANALISE"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "PROCESSADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-checked.sucess-font-color {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "ERRO_PROCESSAMENTO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-delete.error-font-color {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(v-else)
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[3].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-success(
                                    :class='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo === "ELEGIVEL" || scope.row.certificacaoTerritorioResultado[3].resultadoParcial === "ELEGIVEL" ? "elegivel" : "danger-font-color"'
                                )

                    div(v-else)
                        .certificacaoTipo
                            el-icon.el-icon-loading

                    div(v-if='scope.row.certificacaoTerritorioResultado[3].resultadoCodigo !== "NAO_ANALISADO" && scope.row.certificacaoTerritorioResultado[3].resultadoCodigo !== "EM_ANALISE"')
                        el-tooltip(
                            effect='dark',
                            :content='scope.row.certificacoes[3].status ? "Certificado" : "Não certificado"',
                            placement='top'
                        )
                            el-icon.el-icon-star-on(
                                :class='scope.row.certificacoes[3].status ? "certificado" : "nao-certificado"'
                            )
        el-table-column.elegivel(
            prop='certificacaoTerritorioResultado',
            label='EUDR',
            width='75',
            flex='1'
        )
            template(slot-scope='scope')
                .flex-container
                    div(v-if='scope.row.certificacaoTerritorioResultado[4]')
                        .certificacaoTipo(
                            v-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "NAO_ANALISADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove-outline.nao-analisado

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "INELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-error.inelegivel {{ scope.row.certificacaoTerritorioResultado[4].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "PARCIALMENTE_ELEGIVEL"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-warning.parcialmente-elegivel {{ scope.row.certificacaoTerritorioResultado[4].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "NAO_SE_APLICA"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-remove.nao-se-aplica {{ scope.row.certificacaoTerritorioResultado[4].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "LAUDO_SOLICITADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-add.disabled-font-color {{ scope.row.certificacaoTerritorioResultado[4].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "EM_ANALISE"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-loading {{ scope.row.certificacaoTerritorioResultado[4].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "PROCESSADO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-checked.sucess-font-color {{ scope.row.certificacaoTerritorioResultado[4].resultadoNome }}

                        .certificacaoTipo(
                            v-else-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "ERRO_PROCESSAMENTO"'
                        )
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-document-delete.error-font-color {{ scope.row.certificacaoTerritorioResultado[3].resultadoNome }}

                        .certificacaoTipo(v-else)
                            el-tooltip(
                                effect='dark',
                                :content='scope.row.certificacaoTerritorioResultado[4].resultadoNome',
                                placement='top'
                            )
                                el-icon.el-icon-success(
                                    :class='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo === "ELEGIVEL" || scope.row.certificacaoTerritorioResultado[4].resultadoParcial === "ELEGIVEL" ? "elegivel" : "danger-font-color"'
                                )

                    div(v-else)
                        .certificacaoTipo
                            el-icon.el-icon-loading

                    div(v-if='scope.row.certificacaoTerritorioResultado[4].resultadoCodigo !== "NAO_ANALISADO" && scope.row.certificacaoTerritorioResultado[4].resultadoCodigo !== "EM_ANALISE"')
                        el-tooltip(
                            effect='dark',
                            :content='scope.row.certificacoes[4].status ? "Certificado" : "Não certificado"',
                            placement='top'
                        )
                            el-icon.el-icon-star-on(
                                :class='scope.row.certificacoes[4].status ? "certificado" : "nao-certificado"'
                            )
        el-table-column(label='Ações', align='center', width='100', flex='1')
            .template(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    span.el-dropdown-link
                        i.mdi.mdi-dots-vertical
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='detalhamentoAnalise(scope.row.id)'
                        ) Detalhamento da análise

                        el-dropdown-item(
                            icon='el-icon-delete',
                            @click.native='removerCertificacao(scope.row)'
                        ) Remover

                        el-dropdown-item(
                            icon='el-icon-refresh-right',
                            @click.native='abreModalGerarAnalise(scope.row)'
                        ) Gerar nova análise

                        el-dropdown-item(
                            icon='el-icon-document',
                            @click.native='abreModalSolicitarLaudo(scope.row)',
                            v-if='verificaStatusResultadosParaSolicitarLaudo(scope.row)'
                        ) Solicitar Laudo

                        el-dropdown-item(
                            icon='el-icon-document',
                            @click.native='abreModalAcompanharSolicitacaoLaudo(scope.row)',
                            v-if='verificaStatusResultadosAcompanharSolicitacaoLaudo(scope.row)'
                        ) Acompanhar Solicitação de Laudo

    .tabela-gestao-contrato-originacao__paginacao
        div
            span.pagina {{ paginacao.total }} {{ paginacao.total > 1 ? ' territórios' : ' território' }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
</template>

<script>
import formatters from '@/utils/formatters';
import CertificacaoService from '@/services/CertificacaoService';

export default {
    name: 'TabelaGestaoCertificacao',
    emits: [
        'handleModalGerarAnalise',
        'handleModalSolicitarLaudo',
        'handleModalAcompanharSolicitacaoLaudo',
        'handleDownloadLaudo'
    ],
    props: {
        tabelaData: {
            type: Array,
            required: true
        },
        removendo: {
            type: Boolean,
            required: false
        },
        carregando: {
            type: Boolean,
            required: false
        },
        paginacao: {
            type: Object,
            required: true
        },
        btnRecarregar: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            currentPage: 1
        };
    },
    methods: {
        mudarPagina(novaPagina) {
            document.querySelector('#base-header').scrollIntoView();
            this.$emit('mudarPagina', novaPagina - 1);
        },
        formatarNomeTerritorio(nome) {
            return formatters.reduzirTexto(nome);
        },
        formatarCar(car) {
            return formatters.reduzirCar(car);
        },
        formatarArea(area) {
            return formatters.maxFormatNumber(area, 2);
        },
        sortChangeRequest(column) {
            return this.$emit('ordenarTabela', column);
        },
        detalhamentoAnalise(idCertificacao) {
            if (!idCertificacao) return;
            this.$router.push({
                name: 'VisualizarAnalise',
                params: { idCertificacao }
            });
        },
        getPais(uf) {
            const estadosDoBr = [
                { uf: 'AC', pais: 'BR' },
                { uf: 'AL', pais: 'BR' },
                { uf: 'AP', pais: 'BR' },
                { uf: 'AM', pais: 'BR' },
                { uf: 'BA', pais: 'BR' },
                { uf: 'CE', pais: 'BR' },
                { uf: 'DF', pais: 'BR' },
                { uf: 'ES', pais: 'BR' },
                { uf: 'GO', pais: 'BR' },
                { uf: 'MA', pais: 'BR' },
                { uf: 'MT', pais: 'BR' },
                { uf: 'MS', pais: 'BR' },
                { uf: 'MG', pais: 'BR' },
                { uf: 'PA', pais: 'BR' },
                { uf: 'PB', pais: 'BR' },
                { uf: 'PR', pais: 'BR' },
                { uf: 'PE', pais: 'BR' },
                { uf: 'PI', pais: 'BR' },
                { uf: 'RJ', pais: 'BR' },
                { uf: 'RN', pais: 'BR' },
                { uf: 'RS', pais: 'BR' },
                { uf: 'RO', pais: 'BR' },
                { uf: 'RR', pais: 'BR' },
                { uf: 'SC', pais: 'BR' },
                { uf: 'SP', pais: 'BR' },
                { uf: 'SE', pais: 'BR' },
                { uf: 'TO', pais: 'BR' }
            ];
            return estadosDoBr.find(estado => estado.uf === uf)?.pais;
        },
        async removerCertificacao(row) {
            try {
                const result = await this.$messageBox.confirm(
                    `A certificação do território ${row.nomeTerritorio} será excluida. Deseja prosseguir?`,
                    'Aviso',
                    {
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Cancelar',
                        type: 'warning'
                    }
                );
                if (result) {
                    const resultado =
                        await CertificacaoService.removerCertificacao(row.id);
                    this.$notify.success({
                        message: resultado.data
                    });
                    this.$emit('atualizarTabela');
                }
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        },
        abreModalGerarAnalise(row) {
            this.$emit('handleModalGerarAnalise', row);
        },
        verificaStatusResultadosParaSolicitarLaudo(row) {
            for (const resultado of row.certificacaoTerritorioResultado) {
                if (
                    resultado.resultadoCodigo === 'ELEGIVEL' ||
                    resultado.resultadoCodigo === 'INELEGIVEL' ||
                    resultado.resultadoCodigo === 'PARCIALMENTE_ELEGIVEL' ||
                    resultado.resultadoCodigo === 'NAO_SE_APLICA' ||
                    resultado.resultadoCodigo === 'LAUDO_PROCESSADO'
                ) {
                    return true;
                }
            }
            return false;
        },
        abreModalSolicitarLaudo(row) {
            this.$emit('handleModalSolicitarLaudo', row);
        },
        verificaStatusResultadosAcompanharSolicitacaoLaudo(row) {
            for (const resultado of row.certificacaoTerritorioResultado) {
                if (
                    resultado.resultadoCodigo === 'LAUDO_SOLICITADO' ||
                    row.laudoSolicitado
                ) {
                    return true;
                }
            }
            return false;
        },
        abreModalAcompanharSolicitacaoLaudo(row) {
            this.$emit('handleModalAcompanharSolicitacaoLaudo', row);
        },
        async realizarDownloadLaudo(row) {
            this.$emit('handleDownloadLaudo', row);
        }
    }
};
</script>

<style lang="scss">
#bloco-tabela-territorio-gestao {
    h1,
    .el-checkbox {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: break-all;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .el-table td {
        padding: 12px 0px;
        vertical-align: top;
        border-top: 1px solid #e9ecef;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }

    span.el-descriptions-item__label.has-colon {
        font-weight: bold;
    }

    .success-font-color {
        color: var(--success);
    }

    .danger-font-color {
        color: var(--danger);
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }

    .tabela-certificacoes-inseridas-listagem {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
    }

    .el-icon-download {
        font-size: 16px;
        color: var(--primary);
        margin-left: 10px;
        cursor: pointer;
    }
}

i {
    &.parcialmente-elegivel {
        color: var(--warning);
    }
}

.error-font-color {
    color: #e83b3b;
}

.nao-se-aplica {
    font-size: 16px;
    color: #3b9ae8;
}

.parcialmente-elegivel {
    font-size: 16px;
    color: #e8783b;
}

.elegivel {
    font-size: 16px;
    color: var(--success);
}

.inelegivel {
    font-size: 16px;
    color: #e75959;
}

.certificado {
    font-size: 19px;
    color: #ffbf00;
}

.nao-certificado {
    font-size: 19px;
    color: silver;
}

.nao-analisado {
    font-size: 16px;
    color: silver;
}

.el-icon-loading {
    font-size: 16px;
}

.disabled-font-color {
    color: #c0c0c0;
}

.flex-container {
    display: flex;
    align-items: center;
}
</style>
